import React, { useState,useMemo, useEffect} from 'react';
import Select from "react-select";
import 'react-datepicker/dist/react-datepicker.css';
import './Transactions_by_user.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {  useNavigate } from 'react-router-dom';
import {
  Table,
  Form,
  Button,
  InputGroup,
} from 'react-bootstrap';
import Card_link from '../crm/modals/Card_link';
import Modal_proyectos from '../../menus/Modal';
import { currencyFormatter, delete_transactions, get_account_list, load_transactions, set_strategy_to_transaction, upload_transaction_CSV } from '../../../utils/services';
import DatePicker from 'react-datepicker';



function Transactions_by_user  ({user_id, permission, permission_accountant, onSet}) {
    // --- Estado de filtros/orden/columnas ---
    const navigate = useNavigate();   
    const [searchTerm, setSearchTerm] = useState('');
    const [totalAmount, settotalAmount] = useState(0);
    const [usrList, setUsrList] = useState([]);
    const [categoryList, setcategoryList] = useState([]);
    const [initialRows, setinitialRows] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: 'channelName', dir: 'asc' });
    const [fileCSV, setCSVFile] = useState(null);
    const token = localStorage.getItem("token");
    const [selectedUsr, setselectedUsr] = useState(null);
    const [showPendingOnly, setShowPendingOnly] = useState(true);
    const [selectedTransactionId, setselectedTransactionId] = useState(null);
    const today = new Date();
    // Calcular la fecha de hace 30 días
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(today.getDate() - 30);
    const [dateRange, setDateRange] = useState([thirtyDaysAgo, today]);
    const [startDate, endDate] = dateRange;
    const [pendingRecords, setPendingRecords] = useState(0);
    
    const status = useState[""];

    const [isModalOpen, setModalOpen] = useState(false);
   // NEW STATE FOR CHECKBOXES AND BULK ACTIONS
   const [selectedRows, setSelectedRows] = useState([]); // Stores IDs of selected rows
   const [selectedCategoryForBulk, setSelectedCategoryForBulk] = useState(''); // Stores the selected category for bulk update
   
   const [bulkStrategy_id, setbulkStrategy_id] = useState(null);
   const [bulkStrategy_title, setbulkStrategy_title] = useState('');
  


    useEffect(() => {

      fetloadInternalTeam(token,"0");
      if (permission !== "1"){
        if (user_id)
          fetloadcurrentUserTransactions(token,user_id, dateRange);
      }

    }, [token, user_id]); 
    
    

    useEffect(() => {
      if (selectedUsr!=null)
        fetloadcurrentUserTransactions(token,selectedUsr, dateRange);
     
    }, [selectedUsr]); 
  

    // --- cargo todos los usuarios
    async function fetloadInternalTeam(token, type) {
              const usrData = await get_account_list(token, type);
              if (usrData==="INVALID"){
                  navigate("/");
              }
              else{
                const tempUsr_list = usrData["accountlist"].map((celement, index) => {
                  return {
                    id: celement.id,
                    value: celement.id,
                    email_id: celement.email_id,
                    label: celement.usr_name + " ( Pendiente: " +  (celement.pending_amount?  currencyFormatter.format( celement.pending_amount):"$0") + ")",
                    index:index
                  };
                });

                const tempCategory_list = usrData["categoryarray"].map((celement, index) => {
                  return {
                    id: celement.id,
                    category_name: celement.category_name,
                    index:index
                  };
                });

                setcategoryList(tempCategory_list);
                setUsrList(tempUsr_list);
             
              }
        }

 // --- establezco una estrategia
async function setSelectedStrategy(token,trello_card_id, selectedTransactionId, selectedCategory) {
  
        const usrData = await set_strategy_to_transaction(token, trello_card_id, selectedTransactionId, selectedCategory);
        if (usrData==="INVALID"){
            navigate("/");
        }
        else{

          if (selectedUsr!=null){
            fetloadcurrentUserTransactions(token,selectedUsr, dateRange);
         }else{
          if (permission !== "1")  fetloadcurrentUserTransactions(token,user_id, dateRange); 
         }

        }
      }       
      
      async function fetloadcurrentUserTransactions(token, selectedUsr, currentdateRange) {
        if (!(currentdateRange && currentdateRange[0] instanceof Date  && currentdateRange[1] instanceof Date)) {
          return;
        }
        const usrData = await load_transactions(token, selectedUsr,currentdateRange);
        if (usrData==="INVALID"){
            navigate("/");
        }
        else{

          if (usrData !=null){
            const tempUsr_list = usrData.map((celement, index) => {
              return {
                id: celement.id,
                trello_card_id: celement.trello_card_id,
                date_transaction: celement.date_transaction,
                title: celement.title,
                amount: celement.amount,
                description: celement.description,
                bank_category: celement.bank_category,
                original_currency: celement.original_currency,
                category_id: celement.category_id,
                index:index
              };
            });
            setinitialRows(tempUsr_list);

              // Calcular la sumatoria de los amounts
              const calculatedTotalAmount = tempUsr_list.reduce((sum, currentItem) => {
                // Es una buena práctica asegurarse de que amount es un número
                const amountValue = parseFloat(currentItem.amount);
                return sum + (isNaN(amountValue) ? 0 : amountValue);
              }, 0); // El 0 es el valor inicial de 'sum'

              settotalAmount(calculatedTotalAmount); 
            
          }else{
            setinitialRows ([]);
            settotalAmount(0); 
          }

        

        }
  } 

  const handleCSVFileChange = (e) => {
    setCSVFile(e.target.files[0]);
  }

  const importFile = ()=>{

    if (fileCSV ===""){
          alert("Debe selecccionar un archivo");
          return;
    }

    if (selectedUsr == null){
      alert("Debe selecccionar un usario");
      return;
}
    

    async function fetchAddVersion() {
        const packageslist = await upload_transaction_CSV(token, fileCSV, selectedUsr);
        if (packageslist==="INVALID"){
        navigate("/");
        }else{
        
          alert("Importado con éxito");
          fetloadcurrentUserTransactions(token,selectedUsr, dateRange);
        }
    }

    fetchAddVersion();
  }
  
    // --- Filtrado + ordenamiento memoizados ---
    const rows = useMemo(() => {
      let result = initialRows;
  
      if (searchTerm) {
        const term = searchTerm.toLowerCase();
        result = result.filter((r) =>
          Object.values(r).some((v) => String(v).toLowerCase().includes(term))
        );
      }
  
        if (showPendingOnly) {
    result = result.filter((r) => !r.title);
  }
      result = [...result].sort((a, b) => {


        let aVal = a[sortConfig.key];
        let bVal = b[sortConfig.key];

        if (sortConfig.key === 'amount' ){
          
            aVal = parseFloat(aVal);
            bVal = parseFloat(bVal);
        }else if (sortConfig.key === 'Date'){
             aVal = new Date(aVal);
             bVal = new Date(bVal);
        }

        
        
  
        if (aVal === bVal) return 0;
        const order = aVal > bVal ? 1 : -1;
        return sortConfig.dir === 'asc' ? order : -order;

  
      });
  
      setPendingRecords(result.length);
      return result;
    }, [searchTerm, sortConfig, initialRows, showPendingOnly]);
  
    // --- Handlers ---
    const toggleSort = (key) => {
      setSortConfig((prev) => {
        if (prev.key === key) {
          return { key, dir: prev.dir === 'asc' ? 'desc' : 'asc' };
        }
        return { key, dir: 'asc' };
      });
    };

    const add_linked_strategy = (id) => {
      onSet(id);
  
  };

  const onChangeDatePicker = (update) => {
  
    
    setDateRange(update);
    
    if (selectedUsr!=null){
      fetloadcurrentUserTransactions(token,selectedUsr, update);
   }else{
    if (permission !== "1")  fetloadcurrentUserTransactions(token,user_id, update); 
   }
    
  };
  

  const onCategoryChange = (catid, transaction_id) =>{
    setSelectedStrategy(token,"", transaction_id, catid);
  }
  

  const setBulkCategory = (category)=>{
    const selectedTransactionIdsJsonString = selectedRows.join(',');
    //setBulkCategory(category);
    setSelectedStrategy(token,'', selectedTransactionIdsJsonString, category);
    
  }

   async function handleBulkDelete() {

      if (!window.confirm("Are you sure you want to delete all selected transactions?")) {
        return;
      }
    
    const selectedTransactionIdsJsonString = selectedRows.join(',');
    const deletionData = await delete_transactions(token, selectedTransactionIdsJsonString);
        if (deletionData==="INVALID"){
            navigate("/");
        }
        else{
          if (selectedUsr!=null){
            fetloadcurrentUserTransactions(token,selectedUsr, dateRange);
          }else{
            if (permission !== "1")  fetloadcurrentUserTransactions(token,user_id, dateRange); 
          }

        }
             
  }

  

  const setNewStrategy =(trello_card_id, trello_card_title)=>{
    if (selectedRows.length>0){
      const selectedTransactionIdsJsonString = selectedRows.join(',');
      setSelectedStrategy(token,trello_card_id, selectedTransactionIdsJsonString, "");
    }else{
      setSelectedStrategy(token,trello_card_id, selectedTransactionId,'');
    }
    setModalOpen(false); 
}
    // Icono flecha ↑↓
    const SortIcon = ({ col }) =>
      sortConfig.key === col ? (sortConfig.dir === 'asc' ? '↑' : '↓') : '↕';




//BLUK STRATEGIES
 // NEW: Handle header checkbox change
 const handleHeaderCheckboxChange = (e) => {
  if (e.target.checked) {
    setSelectedRows(rows.map(row => row.id));
  } else {
    setSelectedRows([]);
  }
};

// NEW: Handle individual row checkbox change
const handleRowCheckboxChange = (id) => {
  setSelectedRows(prevSelectedRows => {
    if (prevSelectedRows.includes(id)) {
      return prevSelectedRows.filter(rowId => rowId !== id);
    } else {
      return [...prevSelectedRows, id];
    }
  });
};

 // NEW: Function to handle bulk "Add Strategy" button click

  const handleBulkAddStrategy=(e) => {
    setModalOpen(true);
  }

  



  
    // ---------- UI ----------
    return (
      <div className="container-flex py-4 px-4">

        
        <Modal_proyectos isOpen={isModalOpen} onClose={() => setModalOpen(false)} title ="TOMi Strategies select" >
                <Card_link  token_num={token} onSet={(id,title) => setNewStrategy(id, title)}></Card_link>
        </Modal_proyectos>

        <h1 className="mb-4 fw-bold">Conciliation of Expenses</h1>
        {/* Barra de búsqueda + menús */}
        {permission === "1" && (
        <div className="d-flex gap-2 mb-3 flex-wrap align-items-center" > {/* El gap-2 aquí crea el espacio entre los hijos directos */}

            {/* Form Select */}
            {/* Este es un hijo directo del div con d-flex */}
            
          
                 <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={usrList}
                    onChange={(selectedOption) => setselectedUsr(selectedOption.value)}
                    placeholder="Buscar persona..."
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        minWidth: 300, // o usa width: '100%' para expansión completa
                        flex: 1,       // permite que crezca en d-flex
                      }),
                        menu: (provided) => ({
                            ...provided,
                            zIndex: 9999 // Un valor alto para asegurar que aparezca encima de todo
                        }),
                        // Opcional: Si el menú se renderiza en un portal, también puedes ajustar su zIndex
                        menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999
                        })
                    }}
                    isSearchable
                />
           
            <div className="d-flex align-items-center gap-3" > {/* Use d-flex for alignment and gap for spacing */}
                <div className="flex-grow-1"> {/* This div will allow the file input to take available space */}
       
                    <input
                    type="file"
                    id="htmlFileInput" // Add an ID for accessibility (for the label)
                    onChange={(e) => handleCSVFileChange(e)}
                    className="form-control" // Bootstrap 5 class for file input styling
                    accept=".csv"
                    />
                </div>
                <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() =>importFile()}
                >
                    Import new movements
                </Button>
                </div>
 
        </div>   
          ) 
        }
        
        <div className="d-flex flex-wrap align-items-center gap-3 mb-3 p-2 border rounded">

            {/* Filter Any Field */}
            {/* Usamos un contenedor flex para la etiqueta y el control */}
            <div className="d-flex align-items-center flex-grow-1" style={{ minWidth: '250px' }}> {/* flex-grow-1 para que este tome el espacio restante */}
                <Form.Label className="mb-0" style={{ minWidth: '120px' }}>Filter Any Field:</Form.Label> {/* minWidth para dar un ancho mínimo a la etiqueta */}
                <Form.Control
                placeholder="Search transaction..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className='toolbar-control'
                />
                
            </div>
<div className="d-flex align-items-center flex-grow-1" style={{ minWidth: '250px' }}> {/* flex-grow-1 para que este tome el espacio restante */}
            
              <Form.Check
                  type="checkbox"
                  label="Solo pendientes"
                  className="ms-3" // Esto añade un margen izquierdo para separarlo del campo de búsqueda
                  // Aquí puedes agregar un estado y un manejador de eventos para controlar si el checkbox está marcado
                  checked={showPendingOnly}
                   onChange={(e) => setShowPendingOnly(e.target.checked)}
                />
</div>
<div className="d-flex align-items-center flex-grow-1" style={{ minWidth: '250px' }}> {/* flex-grow-1 para que este tome el espacio restante */}
            <Form.Group className="mb-2">
              <InputGroup style={{ minWidth: '150px' }}>
                  <DatePicker
                    selectsRange
                    startDate={startDate}
                    endDate={endDate}
                    onChange={onChangeDatePicker}
                    isClearable={true} // Permite limpiar la selección
                    placeholderText="Seleccionar rango de fechas"
                    className="form-control"
                    dateFormat="dd/MM/yyyy" // Formato de fecha
                    popperClassName="datepicker-popper" 
                    
                  />
                  <InputGroup.Text>
                    <strong style={{ fontSize: '1rem' }}> {/* Ajusta el tamaño de fuente si es necesario */}
                      {currencyFormatter.format(totalAmount)}
                    </strong>
                  </InputGroup.Text>
                </InputGroup>
              
                
            </Form.Group>
</div>
          <div className="d-flex align-items-center flex-grow-1" style={{ minWidth: '250px' }}> {/* flex-grow-1 para que este tome el espacio restante */}
            <strong style={{ fontSize: '2rem' }}>
                Pendientes: {pendingRecords}
            </strong>
          </div>
            </div>

 {/* NEW: Bulk Actions section */}
 {selectedRows.length > 0 && (
          <div className="d-flex gap-3 mb-3 flex-wrap align-items-center p-3 border rounded bg-light">
            <span className="me-2">Selected {selectedRows.length} transactions:</span>
            
            {bulkStrategy_id == null ? (
                <Button variant="success" size="sm" onClick={handleBulkAddStrategy}>
                    Set strategy to all selected
                </Button>
            ) : (
              <Button variant="success" size="sm" onClick={handleBulkAddStrategy}>
                <span className="me-2"> <strong>{bulkStrategy_title}</strong></span>
                 </Button>
            )
            }
            

        
           
            <Form.Select
              size="sm"
              value={selectedCategoryForBulk}
              onChange={((e) => setBulkCategory(e.target.value))}
              className="header-select fs-6"
              style={{ maxWidth: '200px' }} // Limit width for select
            >
              <option value="">Set Category to all selected</option>
              {categoryList.map((opt) => (
                <option key={opt.id} value={opt.id}>{opt.category_name}</option> 
              ))}
            </Form.Select>



             {

             parseInt(permission_accountant) == 1 ? (
                <Button variant="danger" size="sm" onClick={handleBulkDelete}>
                    Delete all selected
                </Button>
            ) : "NO"
            }
         
          </div>



        )}
        {/* Tabla */}
        <Table hover responsive className="align-middle">
          <thead className="table-light">
            <tr >
               <th>
                    <Form.Check
                        type="checkbox"
                        checked={rows.length > 0 && selectedRows.length === rows.length}
                        onChange={handleHeaderCheckboxChange}
                    />
                </th>
                <th onClick={() => toggleSort('date_transaction')} role="button">
                   Date <SortIcon col="date_transaction" />
                </th>
                <th onClick={() => toggleSort('description')} role="button">
                  Description <SortIcon col="description" />
                </th>
                <th onClick={() => toggleSort('bank_category')} role="button">
                    Bank Description <SortIcon col="bank_category" />
                </th>
                <th onClick={() => toggleSort('original_currency')} role="button">
                    Origin Currency <SortIcon col="original_currency" />
                </th>
                <th  role="button">
                    Category 
                </th>
                <th onClick={() => toggleSort('title')} role="button">
                    Estrategia <SortIcon col="title" />
                </th>
                <th onClick={() => toggleSort('amount')} role="button">
                    Amount <SortIcon col="amount" />
                </th>

             
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.id}  value={row.id} className={!row.title || row.title.trim() === '' ? 'table-danger' : ''}>
                 <td>
                    <Form.Check
                        type="checkbox"
                        checked={selectedRows.includes(row.id)}
                        onChange={() => handleRowCheckboxChange(row.id)}
                    />
                </td>
                <td>{row.date_transaction}</td>
                <td>{row.description}</td>
                <td>{row.bank_category}</td>
                <td>{row.original_currency}</td>
                <td>
                 <Form.Select
                    size="sm"
                    value={row.category_id}
                    onChange={(e) => onCategoryChange(e.target.value, row.id)}
                    className="header-select fs-6"  
                    >
                    <option value="">Select Category</option>
                    {categoryList.map((opt) => (
                        <option key={opt.id} value={opt.id}>{opt.category_name}</option> 
                    ))}
                </Form.Select>
                    </td>
                            <td  onClick={(e) => {
                                e.stopPropagation(); 
                                setselectedTransactionId(row.id);
                                setModalOpen(true);
                            }}> {!row.title || row.title.trim() === '' ? (
                        // If strategy is empty, show a button
                        // You might want to use a Bootstrap Button component if you're using react-bootstrap
                            <button
                              className="btn btn-sm btn-primary" // Example Bootstrap button classes
                                >
                                Add Strategy
                                </button>
                            ) : (
                                // If strategy is not empty, show the strategy value
                                row.title
                            )}
                    </td>
                <td>{row.amount}</td>
              </tr>
              
            ))}
            {rows.length === 0 && (
              <tr>
                <td colSpan="10" className="text-center py-4">
                  No results
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    );
};

export default Transactions_by_user;
